import { render, staticRenderFns } from "./CdbCustomerContact.vue?vue&type=template&id=6696121b&scoped=true&"
import script from "./CdbCustomerContact.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerContact.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerContact.vue?vue&type=style&index=0&id=6696121b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6696121b",
  null
  
)

export default component.exports